import { render, staticRenderFns } from "./RedirectsView.vue?vue&type=template&id=4fd84164&"
import script from "./RedirectsView.vue?vue&type=script&lang=js&"
export * from "./RedirectsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd84164')) {
      api.createRecord('4fd84164', component.options)
    } else {
      api.reload('4fd84164', component.options)
    }
    module.hot.accept("./RedirectsView.vue?vue&type=template&id=4fd84164&", function () {
      api.rerender('4fd84164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/domains/RedirectsView.vue"
export default component.exports